<template>
  <MediaPage
    :baseurl="endpoint('internal/current/mediaimages/')"
    title="Media Upload"
  />
</template>

<script setup>
import MediaPage from "../components/MediaPage.vue";
import { endpoint } from "../remote/utils.js";

</script>

<style scoped>

</style>
